import { stringify } from "qs";
import axios from 'axios';

/**
 *
 *  Language Banner/Buttons
 *
 *  */
document.addEventListener('click', function(event) {
    // Make sure clicked element is our toggle
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains('js-change-language') || el.classList.contains('disabled') === true) {
        return;
    }

    el.classList.add('disabled');

    // Prevent default link behavior
    event.preventDefault();
    const source = el.getAttribute('data-source');
    const original_preference = el.getAttribute('data-original-preference');
    const new_preference = el.getAttribute('data-new-preference');

    if (source === 'toggle') {
        const cog = el.querySelector('.fa-cog');
        if (cog !== null) {
            cog.classList.add('fa-spin');
        }

        const switchIcon = el.querySelector('.fa-repeat');
        if (switchIcon !== null) {
            switchIcon.classList.add('fa-spin');
        }
    }

    changeLanguage(source, original_preference, new_preference)
}, false);

/**
 *
 *  Language Overlay
 *
 *  */
document.addEventListener('change', function(event) {
    // Make sure clicked element is from language overlay
    const el = /** @type {HTMLFormElement} */ (event.target);

    if (!el.classList.contains('js-overlay-change-language')) {
        return;
    }

    event.preventDefault();

    // Change language
    let original_preference = el.getAttribute('data-original-preference');
    let new_preference = el.value;

    changeLanguage('overlay', original_preference, new_preference);
});


document.addEventListener('DOMContentLoaded', function() {
    // add event listener to buttons which change language
    document.querySelectorAll('.change-language-switch').forEach(function(el) {
        el.addEventListener('click', function(event) {
            event.preventDefault();
            const source = el.getAttribute('data-source');
            const original_preference = el.getAttribute('data-original-preference');
            const new_preference = el.getAttribute('data-new-preference');

            changeLanguage(source, original_preference, new_preference)
        })
    })

    // add fixed class to language banner when we scroll past it
    var langBanner = document.getElementById("js-language-overlay");
    if (!langBanner) {
        return;
    }

    var offset = langBanner.offsetTop;
    window.addEventListener("scroll", function() {
        var scrollPosition = window.scrollY;

        if (scrollPosition + 16 >= offset) {
            langBanner.classList.add("fixed");
        } else {
            langBanner.classList.remove("fixed");
        }
    });
})


function changeLanguage(source, original_preference, new_preference) {
    axios({
        url: '/backend/user/update_language_preference',
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: stringify({
            source,
            original_preference,
            new_preference,
            change_language: original_preference != new_preference ? true : false
        }),
    }).then(() => {
        if (original_preference === new_preference)  document.getElementById("js-language-overlay")?.classList.add("d-none");

        window.location.href = window.location.href.replace(/lang_pref=(en|af)/, '').replace(/lang=(en|af)/, '').replace(/#.*/, "");
    });
}
